






























import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const progress = namespace('progress')

@Component({
  name: 'TetrisMenu',
})
export default class Settings extends Vue {
  @Prop() hasGameProgress!: boolean

  @progress.State indexScore

  @progress.Getter getScore

  isShow: boolean = false

  get buttons():object[] {
    return [
      {
        name: 'Resume',
        class: 'btn-green',
        isShow: this.hasGameProgress,
        click: this.onClickResume,
      },
      {
        name: 'New game',
        class: this.hasGameProgress ? 'btn-orange' : 'btn-green',
        isShow: true,
        click: this.onClickNewGame,
      },
      {
        name: 'Highscores',
        class: 'btn-blue',
        isShow: this.getScore.length,
        click: this.onClickHighscores,
      },
    ]
  }

  get isNewHighscore(): boolean {
    return !!this.getScore[this.indexScore]
  }

  onClickResume(): void {
    this.$emit('tetris:resume')
  }

  onClickNewGame(): void {
    this.$emit('tetris:new-game')
  }

  onClickHighscores(): void {
    this.isShow = !this.isShow
  }
}
